import classes from './CardContent.module.scss';
import RelatedCards from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/relatedCards/relatedCards';
import ActivityLog from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/activityLog/activityLog';
import { generatePath, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { Control, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';
import { IActiveTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import qs from 'qs';
import { CardDetails } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/RecommendationCard/CardContent/CardDetails/CardDetails';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/RecommendationCard/RecommendationCard.utils.types';
import { QueryResponse as IBoardInitResponse } from 'api/queries/getBoardInitLite.query';

interface ICardContentProps {
    activeTab: IActiveTab;
    boardInit: IBoardInitResponse | undefined;
    setValue: UseFormSetValue<IFields>;
    watch: UseFormWatch<IFields>;
    control: Control<IFields, IFields>;
    errors: FieldErrors<IFields>;
    data: CardResponse;
    queryKeys?: string[];
}

export const CardContent = ({
    activeTab,
    boardInit,
    setValue,
    watch,
    control,
    errors,
    data,
    queryKeys = [],
}: ICardContentProps) => {
    const history = useHistory();
    const { path } = useRouteMatch();
    const params = useParams();
    const { search } = useLocation();

    const handleCreateUserAction = () => {
        const newSearch = qs.stringify({ ...qs.parse(search), taskId: data.taskId });
        const pathname = generatePath(path, { ...params, cardId: 'newCard' });
        setTimeout(() => {
            history.push({
                pathname,
                search: newSearch,
            });
        }, 0);
    };

    return (
        <div className={classes.cardContentContainer}>
            {activeTab === 'cardDetails' && (
                <CardDetails
                    boardInit={boardInit}
                    setValue={setValue}
                    watch={watch}
                    control={control}
                    errors={errors}
                    data={data}
                    queryKeys={queryKeys}
                />
            )}

            {activeTab === 'relatedCards' && (
                <RelatedCards
                    id={data.id}
                    taskId={data.taskId}
                    isVirtual={data.isVirtual}
                    handleCreateUserAction={handleCreateUserAction}
                    versionName={watch('versionName')}
                />
            )}

            {activeTab === 'auditLogs' && (
                <ActivityLog id={data.id} isVirtual={data.isVirtual} versionName={watch('versionName')} />
            )}
        </div>
    );
};
